import { render, staticRenderFns } from "./FormSwitch.vue?vue&type=template&id=5a8a7e22&scoped=true&"
import script from "./FormSwitch.vue?vue&type=script&lang=js&"
export * from "./FormSwitch.vue?vue&type=script&lang=js&"
import style0 from "./FormSwitch.vue?vue&type=style&index=0&id=5a8a7e22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8a7e22",
  null
  
)

export default component.exports